import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Permission } from '../../domain/permissions';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';

type ModifyGroupData = {
    id: string;
    name: string;
    description: string;
    permissions: Permission[];
}

export const useModifyGroupRepository = () => {
    const { getJwtToken } = useAuthentication();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (data: ModifyGroupData) => {
            const { id, ...body } = data;
            const token = await getJwtToken();

            const response = await fetch(`${BACKEND_URL}/groups/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error('Failed to modify group');
            }

            return await response.json();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['groups'] });
        },
    });

    return {
        modifyGroup: mutation.mutateAsync,
        ...mutation,
    };
};
